module.exports = __webpack_public_path__ + "static/media/nowinsg-desktop.6ec8e10e.png";